<template>
  <div>
    <div class="flex justify-between items-center">
      <Lynx-Title text="Todas as Empresas" />
      <Lynx-Button class="mb-8" text="Atualizar Empresas" outlined="true" @click.native="fetchAllEmpresas" />

      <router-link class="mb-8" :to="{ name: 'empresas.index' }">
        <Lynx-Button text="Voltar" icon="ArrowLeft" outlined="true" />
      </router-link>
    </div>

    <div class="w-full flex justify-between items-end pb-6">
      <div class="w-1/5">
        <b-field label="Status">
          <b-select placeholder="Selecione um status" v-model="filtros.status">
            <option
              v-for="(item, key) in status_empresas"
              :value="item.name"
              :key="key"
            >
              {{ item.description }}
            </option>
          </b-select>
        </b-field>
      </div>
      <label class="w-1/5">
          <b-field label="Tipo endereco">
            <b-select v-model="filtros.endereco_tipo">
              <option value="Residencial">Residencial</option>
              <option value="Clínica Física">Clínica Física</option>
              <option value="Coworking">Coworking</option>
            </b-select>
          </b-field>
      </label>
           <label class="w-1/4">
        <Lynx-Label label="ID Empresas" class=" " />

        <input
          class="border-primary-200 bg-white px-2 border-l-4 border-solid rounded py-1 w-full transition focus:shadow focus:border-r-4 font-light"
          v-model="empresas_id"
          v-on:keyup.enter="fetchAllEmpresas"
        />
      </label>
      <label class=" ">
        <Lynx-Label label="Por paginas" class=" " />

        <b-select v-model="filtros.perPage">
          <option
            :value="perPageOption"
            v-for="perPageOption in perPageOptions"
            :key="perPageOption"
          >
            {{ perPageOption }}
          </option>
        </b-select>
      </label>
      <div class="flex-col">
        <Lynx-Button
          color="neutral-800"
          text="Relatorio Empresas"
          icon="Search"
          icon-size="4"
          size="small"
          @click.native="gerarRelatorio"
        />
      </div>
    </div>

    <div class="flex justify-center" v-if="loading">
      <Lynx-Spinner size="16" />
    </div>
    <b-table
      :data="empresas"
      :columns="columns"
      :paginated="true"
      default-sort-direction="asc"
      default-sort="id"
      class="w-full"
      v-else
      :loading="loading"
      backend-pagination
      @page-change="onPageChange"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      :total="pagination.total"
      :current-page="pagination.current_page"
      :per-page="pagination.per_page"
      striped
    >
      <template slot-scope="props">
        <b-table-column field="id" v-text="props.row.id" />
        <b-table-column field="razao_social" v-text="props.row.razao_social" />
        <b-table-column>
          <b-tag v-if="props.row.status === 'desativada'" type="is-danger"
            >Desativada</b-tag
          >
          <b-tag
            v-if="props.row.status === 'desativacao_agendada'"
            type="is-warning"
            >Desativação Agendada</b-tag
          >
          <b-tag v-if="props.row.status === 'congelada'" type="is-warning"
            >Congelada</b-tag
          >
          <b-tag v-if="props.row.status === 'abertura'" type="is-primary"
            >Em Abertura</b-tag
          >
          <b-tag v-if="props.row.status === 'normal'" type="is-default"
            >Normal</b-tag
          >
          <b-tag v-if="props.row.status === 'residencia'" type="is-info"
            >Residência</b-tag
          >
        </b-table-column>
        <b-table-column field="acoes">
          <div class="flex text-sm items-center">
            <Tooltip content="Detalhes">
              <a
                href="#"
                class="bg-primary-600 rounded-full p-2"
                @click.prevent="openDetailsModal(props.row.id)"
              >
                <Icon-Document class="text-neutral-100" size="4" />
              </a>
            </Tooltip>
          </div>
        </b-table-column>
      </template>
    </b-table>
    <b-modal :active.sync="detailsModal">
      <Detalhes
        :empresa-id="currentEmpresaId"
        @close-modal="onCloseDetailsModal"
      />
    </b-modal>
  </div>
</template>

<script>
import { allEmpresasRequest } from "@/services/requests/empresas";
import Tooltip from "@/components/globals/Tooltip";
import Detalhes from "@/views/empresas/all/Detalhes";

export default {
  name: "EmpresasAll",
  components: { Tooltip, Detalhes },
  data() {
    return {
      empresas: [],
      loading: false,
      detailsModal: false,
      currentEmpresaId: null,
      selectedStatus: null,
      status_empresas: [
        {
          name: null,
          description: "Todas",
        },
        {
          name: "desativada",
          description: "Desativada",
        },
        {
          name: "normal",
          description: "Normal",
        },
        {
          name: "abertura",
          description: "Em Abertura",
        },
        {
          name: "congelada",
          description: "Congelada",
        },
        {
          name: "residencia",
          description: "Residência",
        },
      ],
      columns: [
        {
          field: "id",
          label: "ID",
          sortable: true,
        },
        {
          field: "razao_social",
          label: "Razão Social",
          sortable: true,
        },
        {},
        {
          field: "acoes",
          label: "Ações",
        },
      ],
      filtros: {
        page: 1,
        empresas_id: null,
        perPage: 10,
        status: null,
        endereco_tipo:null,
      },
      perPageOptions: [10, 50, 100],
      current_page: 1,
      empresas_id: null,
      pagination: {},
    };
  },
  computed: {
    // filteredEmpresas: function () {
    //   return this.empresas.filter((item) => {
    //     if (!this.selectedStatus) return true;
    //     return item.status === this.selectedStatus;
    //   });
    // },
  },
  watch: {
    "filtros.perPage"() {
      this.fetchAllEmpresas();
    },
    "filtros.status"() {
      this.fetchAllEmpresas();
    },
    current_page() {
      this.filtros.page = this.current_page;
      this.fetchAllEmpresas();
    },
  },
  methods: {
    fetchAllEmpresas() {
      this.loading = true;
      if (this.empresas_id) {
        this.filtros.empresas_id = this.empresas_id.split(",");
      } else {
        this.filtros.empresas_id = null;
      }

      const { filtros } = this;

      allEmpresasRequest(filtros)
        .then((res) => {
          this.empresas = res.data.data;
          this.pagination = res.data.pagination;
        })

        .finally(() => (this.loading = false));
    },
    openDetailsModal(id) {
      this.currentEmpresaId = id;
      this.detailsModal = true;
    },
    onCloseDetailsModal() {
      this.detailsModal = false;
      this.currentEmpresaId = null;
    },
    onPageChange(page) {
      this.current_page = page;
    },
    async gerarRelatorio() {
      // this.loading = true;
      if (this.empresas_id) {
        this.filtros.empresas_id = this.empresas_id.split(",");
      } else {
        this.filtros.empresas_id = null;
      }
      const { filtros } = this;

      await this.$store.dispatch("empresas/gerarRelatorioEmpresa", filtros);
      // this.loading = false;
    },
  },
  beforeMount() {
    this.fetchAllEmpresas();
  },
};
</script>
